module.exports = __webpack_public_path__ + "static/media/design_flexibility_bg_icon_svg.564972a5.svg";